import { Component, Inject, OnInit } from "@angular/core";
// import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { SharedService } from "@shared/services/shared.service";
import { IEnclosedAreaFileView } from "app/models/reports/reports";
import { ComplaintService } from "app/services/complaint/complaint.service";

@Component({
  selector: 'enclosedAreaFile',
  styleUrls: ['./enclosedAreaFile.component.scss'],
  templateUrl: './enclosedAreaFile.component.html'
})

export class EnclosedAreaFileComponent implements OnInit {

  file: File;
  businessId: number = 0;
  saved: boolean = false;
  fileName: string = '';
  enclosedAreaId: string = '';



  constructor(
    private sharedService: SharedService,
    private complaintService: ComplaintService,
    // private datePipe: DatePipe,
    private dialogRef: MatDialogRef<EnclosedAreaFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
      this.enclosedAreaId = this.data.enclosedAreaId;
  }

  ngOnInit(): void {
    this.saved = false;
    // this.ids = this.citation.id > 0 ? true : false;
  }

  addFile() {
    if (this.file != null) {
      let formData = new FormData();
      formData.append('enclosedAreaId', this.enclosedAreaId);
      formData.append('fileToUpload', this.file, this.file.name);

      this.complaintService.addEnclosedAreaDocument(formData).subscribe(
        (result) => {
          this.sharedService.toastr.success("File Saved Successfully");
          this.saved = true;
          this.return();
        },
        error => {
          this.sharedService.toastr.error("Could not save file: " + error.message);
        }
      );
    }
    else {
      this.sharedService.toastr.error("No file selected");
    }
  }

  uploadFile(event): void {
    this.file = event.target.files[0];
    this.fileName = this.file.name;
  }

  return(): void {
    let returnData = this.saved ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }

}